/**
 * @generated SignedSource<<e72d87f5e6080935e44213763ce6f7c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BigDecimalRangeFilter = {
  from?: any | null | undefined;
  to?: any | null | undefined;
};
export type moduleRatingsTable_Refetch$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  value?: BigDecimalRangeFilter | null | undefined;
};
export type moduleRatingsTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"moduleRatingsTable_RefetchableQueryFragment">;
};
export type moduleRatingsTable_Refetch = {
  response: moduleRatingsTable_Refetch$data;
  variables: moduleRatingsTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRatingsTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "moduleRatingsTable_RefetchableQueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moduleRatingsTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModuleRatingAdminSchema",
            "kind": "LinkedField",
            "name": "ModuleRating",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "ModuleRatingCalculationTypesConnection",
                "kind": "LinkedField",
                "name": "ModuleRatingCalculations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleRatingCalculationTypesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ModuleRatingCalculation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nodeRef",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "score",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "value"
                ],
                "handle": "connection",
                "key": "moduleRatingsTable_ModuleRatingCalculations",
                "kind": "LinkedHandle",
                "name": "ModuleRatingCalculations"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f43b05e69058095bdee07f645cc0832b",
    "id": null,
    "metadata": {},
    "name": "moduleRatingsTable_Refetch",
    "operationKind": "query",
    "text": "query moduleRatingsTable_Refetch(\n  $after: String\n  $first: Int\n  $value: BigDecimalRangeFilter\n) {\n  ...moduleRatingsTable_RefetchableQueryFragment_2nHH7l\n}\n\nfragment moduleRatingsTable_ModuleRatingCalculationInlineFragment on ModuleRatingCalculation {\n  nodeRef\n  node {\n    id\n    structureDefinition {\n      __typename\n      title\n    }\n  }\n  amount\n  score\n}\n\nfragment moduleRatingsTable_RefetchableQueryFragment_2nHH7l on Query {\n  Admin {\n    ModuleRating {\n      ModuleRatingCalculations(first: $first, after: $after, value: $value) {\n        edges {\n          node {\n            ...moduleRatingsTable_ModuleRatingCalculationInlineFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2e4013c7adeeb91cd4b3a396f811252";

export default node;
